import { FC } from 'react';
import ISvgProps from '../SvgLoader/ISvgProps';

export const DowntimeDesktopIcon: FC<ISvgProps> = () => {
	return (
		<svg width="326" height="183" viewBox="0 0 326 183" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g filter="url(#filter0_dd_30_385)">
				<rect x="25" y="6" width="295" height="165" rx="8" fill="#F7F9FC" />
				<rect x="25.5" y="6.5" width="294" height="164" rx="7.5" stroke="#CAD7FF" />
				<path d="M25 15C25 10.5817 28.5817 7 33 7H312C316.418 7 320 10.5817 320 15V22H25V15Z" fill="#CAD7FF" />
				<circle cx="38.5" cy="14.5" r="2.5" fill="white" />
				<circle cx="45.1667" cy="14.5" r="2.5" fill="white" />
				<circle cx="51.8333" cy="14.5" r="2.5" fill="white" />
				<rect x="34.5" y="37.5" width="62" height="17" rx="7.5" stroke="#B4B8C2" strokeDasharray="2 2" />
				<rect x="105.5" y="37.5" width="206" height="17" rx="7.5" stroke="#B4B8C2" strokeDasharray="2 2" />
			</g>
			<circle cx="33" cy="148" r="31" fill="#7D9AFF" stroke="white" strokeWidth="4" />
			<path
				d="M23.782 135.431C25.5318 134.791 27.5607 135.191 28.9612 136.631C30.3621 138.07 30.7512 140.156 30.1284 141.955L45.5172 157.771L42.5071 160.864L27.1166 145.049C25.3668 145.689 23.338 145.289 21.9374 143.849C20.5365 142.409 20.1475 140.324 20.7703 138.525L23.9442 141.787C24.7755 142.641 26.1232 142.641 26.9544 141.787C27.7857 140.932 27.7857 139.547 26.9544 138.693L23.782 135.431ZM38.4935 138.177L43.0088 135.599L45.0156 137.662L42.5071 142.302L39.9985 142.818L36.9884 145.912L34.9816 143.849L37.9918 140.756L38.4935 138.177ZM28.4595 149.521L31.4697 152.615L24.4459 159.833C23.6147 160.688 22.267 160.688 21.4357 159.833C20.6534 159.029 20.6074 157.755 21.2977 156.896L21.4357 156.74L28.4595 149.521Z"
				fill="white"
			/>
			<rect x="34.5" y="65.5" width="38.5655" height="13" rx="6.5" stroke="#B4B8C2" strokeDasharray="2 2" />
			<rect x="81.3539" y="65.5" width="77.0899" height="13" rx="6.5" stroke="#B4B8C2" strokeDasharray="2 2" />
			<rect x="166.732" y="65.5" width="144.768" height="13" rx="6.5" stroke="#B4B8C2" strokeDasharray="2 2" />
			<defs>
				<filter
					id="filter0_dd_30_385"
					x="19"
					y="0"
					width="307"
					height="183"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB">
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="6" />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0577961 0 0 0 0 0.0804438 0 0 0 0 0.185189 0 0 0 0.1 0"
					/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_30_385" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset />
					<feGaussianBlur stdDeviation="3" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0.0577961 0 0 0 0 0.0804438 0 0 0 0 0.185189 0 0 0 0.12 0"
					/>
					<feBlend mode="normal" in2="effect1_dropShadow_30_385" result="effect2_dropShadow_30_385" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_30_385" result="shape" />
				</filter>
			</defs>
		</svg>
	);
};
